import { AxiosError, AxiosPromise, AxiosResponse } from 'axios'
import { Delete } from './Delete'
import { Get } from './Get'
import { Post } from './Post'
import { Put } from './Put'
import { ApiHelpers, APIHosts } from './ApiHelpers'

interface UpdateRoleParams {
  roleName: string
  newRoleName: string
}

export interface OrgRoleItemResponse {
  id: string
  name: string
  normalizedName: string
  organizationId: string
  allowEdit?: boolean
}

export interface ProductClaim {
  claimType: string
  claimValue: string
  parentClaimValue?: string | null
  isGranted?: boolean
}

export type PermissionValue = boolean | 'NOT_EXIST' | 'PARTIAL'

export const actionSuffixs = [
  'Read',
  'Volume',
  'Value',
  'Create',
  'Update',
  'Delete',
  'Print',
  'Import',
  'Export',
  'Confirm',
  'Manage',
]

export interface PermissionNode {
  id: string
  key: string
  name: string
  displayName: string
  parentId: string | null
  parentName: string | null
  permissions: Record<string, PermissionValue>
  children?: PermissionNode[]
}

export interface ProductClaimData {
  clientId: string
  roleId: string
  productClaims: ProductClaim[]
}

class RoleServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager

  public Put = {
    updateOrganizationRole: (id: string, data: UpdateRoleParams) => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizations/${id}/organizationRoles`
      return Put(url, data)
    },
    updateProductClaims: (data: ProductClaimData) => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizationRoles/productClaims`
      return Put(url, data)
    },
  }

  public Get = {
    getOrganizationRoles: (
      orgId: string,
    ): AxiosPromise<OrgRoleItemResponse[] | AxiosError> => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizations/${orgId}/organizationRoles`
      return Get(url)
    },
    getProducClaimsOfRole: (
      clientId: string,
      roleId: string,
    ): AxiosPromise<OrgRoleItemResponse[] | AxiosError> => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizationRoles/productClaims`
      return Get(url, {
        params: { clientId, roleId },
      })
    },
  }

  public Post = {
    createOrganizationRole: (orgId: string, newRoles: string[]) => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizations/${orgId}/organizationRoles`
      return Post(url, newRoles)
    },
  }

  public Delete = {
    removeRoleFromOrganization: (
      organizationId: string,
      roles: string[],
    ): AxiosPromise<AxiosResponse<OrgRoleItemResponse> | AxiosError> => {
      const baseUrl = this.getHost(this.ApiHost)
      return Delete(
        `${baseUrl}/organizations/${organizationId}/organizationRoles`,
        roles,
      )
    },
  }
}

export const RoleService = new RoleServiceController()
